export default "__VITE_ASSET__icr07K_s__"